export const leadTypes = [
  {
    name: 'Padrão',
    value: 'is_default'
  },
  {
    name: 'Conversão',
    value: 'is_conversion'
  },
  {
    name: 'Perdido',
    value: 'is_lost'
  }
];
